import { render, staticRenderFns } from "./user-notes.vue?vue&type=template&id=bfeb441e&"
import script from "./user-notes.vue?vue&type=script&lang=js&"
export * from "./user-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports